import * as React from "react";

const IconPaginationArrowRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
            <g fill="none" fillRule="evenodd">
                <g strokeLinejoin="inherit">
                    <circle cx="26" cy="26" r="25" fill="currentColor" stroke="#FFF" strokeWidth="2" />
                    <circle cx="26" cy="26" r="25.5" stroke="currentColor" />
                </g>
                <polygon fill="#fff" fillRule="nonzero" points="34 26 22 36 22 16" />
            </g>
        </svg>
    );
};

export default React.memo(IconPaginationArrowRight);
